// extracted by mini-css-extract-plugin
module.exports = {"root":"RichTextBlok_root__QwZ6c","text":"RichTextBlok_text__5r1QZ","center":"RichTextBlok_center__D0Vf6","title":"RichTextBlok_title__aefIT"};